// Half-card navigation zones for the flipbook cover + sub-slide cards.
//
// The zones cover the WHOLE card (left half = prev, right half = next), so they sit
// under every widget on the page. Anything interactive therefore needs to be excluded
// or a click meant for it turns the page instead.

// Which nav zone a pointer event falls in, or null. `excludeTopPx` ignores the in-card
// menu-bar strip so its buttons keep their own cursor + click handling.
export const navZoneAt = (e, excludeTopPx = 0) => {
  const rect = e.currentTarget.getBoundingClientRect();
  if (!rect.width) return null;
  if (excludeTopPx && (e.clientY - rect.top) < excludeTopPx) return null;
  return (e.clientX - rect.left) < rect.width / 2 ? 'left' : 'right';
};

// Content that owns its own clicks. Widgets carrying an action already call
// stopPropagation (button/image/shape/text/…); this covers everything that is
// interactive by nature but has no action handler of its own to stop the bubble —
// notably the video widget and the inline asset viewer.
// Add `data-cs-no-flip-nav` to opt any other element out.
export const NAV_EXCLUDE_SELECTOR = [
  // native interactive / media elements
  'video', 'audio', 'iframe', 'embed', 'object', 'canvas',
  'a[href]', 'button', 'input', 'select', 'textarea', 'label',
  '[role="button"]', '[role="link"]', '[contenteditable="true"]',
  // asset viewer (inline video / document) and other live surfaces
  '.cs_asset_widget', '.cs_live_element', '.cs_hotspot_widget',
  '[data-cs-no-flip-nav]',
].join(',');

// True when the event started inside interactive content within this card.
export const isNavBlockedTarget = (e) => {
  const { target, currentTarget } = e;
  if (!target || typeof target.closest !== 'function') return false;
  // Portaled content — the asset viewer's lightbox, modal widgets — bubbles through
  // the REACT tree to this handler while living OUTSIDE the card in the DOM. Such a
  // click never happened on the card, so the half-card geometry is meaningless for it.
  if (typeof currentTarget.contains === 'function' && !currentTarget.contains(target)) {
    return true;
  }
  const hit = target.closest(NAV_EXCLUDE_SELECTOR);
  // `closest` can escape the card (e.g. an ancestor <a>) — only count hits inside it.
  return !!hit && currentTarget.contains(hit);
};
